export default "__VITE_ASSET__CRTdXYEd__"